import { encodeImageName } from '@planter/common/src/utils/general.utils';
export var getImageUrl = function (path, hasBaseUrl) {
    if (hasBaseUrl === void 0) { hasBaseUrl = false; }
    if (!path)
        return;
    return "".concat(!hasBaseUrl ? process.env.REACT_APP_BASE_URL_CLOUDFRONT : '').concat(encodeImageName(path));
};
